import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'

import { quickFilterChanged, treeToggled } from './receiptsSlice'
import { nodePatch } from './tree'
import type { ReceiptsActions } from './types'

/**
 * Действия дерева, дней и чипов журнала для binding: `{ ...base, ...createJournalViewActions(rid, dispatch) }`.
 * Каждое меняет отбор сразу и целиком (`quickFilterChanged`): выдача начинается с первой страницы.
 */
export function createJournalViewActions(
  resourceId: string,
  dispatch: Dispatch<UnknownAction>,
): Pick<ReceiptsActions, 'nodeChosen' | 'nodeToggled' | 'periodChanged' | 'kindChanged' | 'cashierChanged'> {
  return {
    nodeChosen: (nodeId) => {
      const patch = nodePatch(nodeId)
      if (patch !== null) dispatch(quickFilterChanged({ resourceId, patch }))
    },
    nodeToggled: (nodeId) => dispatch(treeToggled({ resourceId, nodeId })),
    periodChanged: (range) => dispatch(quickFilterChanged({ resourceId, patch: { dateFrom: range.from, dateTo: range.to, shiftNumber: '' } })),
    kindChanged: (kind) => dispatch(quickFilterChanged({ resourceId, patch: { kind } })),
    cashierChanged: (cashier) => dispatch(quickFilterChanged({ resourceId, patch: { cashier } })),
  }
}
